import {
  Grid,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Spinner,
  Typography,
  IconButton
} from '@paintscout/ui'
import type { DialogProps } from '@paintscout/ui'
import { UserTiles, useUser, useClientOptions } from '@paintscout/ui-business'
import CloseIcon from '@material-ui/icons/Close'
import type { UserAssignments } from 'paintscout'
import React from 'react'
import { useShareWithTeamDialogStyles } from 'src/components/pages/scheduling/PainterScheduleView/ShareWithTeamDialog/useShareWithTeamDialogStyles'
import { useSelectStaffDialog } from './useSelectStaffDialog'

export interface SelectStaffDialogProps extends DialogProps {
  currentUsers: UserAssignments
  currentCrewIds?: string[]
  isOptions?: boolean
  ownerId?: string
  onConfirm: (assignedUserIds: UserAssignments, crewIds: string[]) => void
  onCancel: () => void
}

function SelectStaffDialog(props: SelectStaffDialogProps) {
  const {
    onCancel,
    onConfirm,
    currentUsers,
    currentCrewIds = [],
    ownerId,
    isOptions = false,
    loading: propLoading,
    open,
    ...baseDialogProps
  } = props
  const classes = useShareWithTeamDialogStyles()
  const { isSuperadmin } = useUser()
  const { clientId } = useClientOptions()

  const { users, queryLoading, hasChanges, assignedUserIds, newAssignedUsers, handleAssignUser } = useSelectStaffDialog(
    {
      currentUsers,
      currentCrewIds,
      ownerId,
      isSuperadmin,
      clientId
    }
  )

  const dialogLoading = propLoading || queryLoading

  return (
    <Dialog open={open} maxWidth="md" {...baseDialogProps}>
      <DialogTitle
        loading={dialogLoading}
        classes={{ root: classes.dialogTitle }}
        rightContent={
          <IconButton size="small" onClick={onCancel} disabled={dialogLoading}>
            <CloseIcon />
          </IconButton>
        }
      >
        <Typography variant="h3">{isOptions ? `Select Default Asignees` : 'Share with Staff'}</Typography>
      </DialogTitle>
      <DialogContent>
        {queryLoading && <Spinner fullWidth fullHeight />}
        {!queryLoading && (
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                {isOptions
                  ? 'Selected users will be assigned to newly created Invoices by default.'
                  : users.length > 0
                    ? `Selected users can open this document`
                    : `There is no one else to share this document with`}
              </Typography>
              {users.length > 0 && (
                <UserTiles users={users} selectedUserIds={assignedUserIds} onUserSelect={handleAssignUser} />
              )}
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          type="submit"
          variant={'contained'}
          onClick={() => onConfirm(newAssignedUsers, [])}
          disabled={!hasChanges || dialogLoading}
        >
          Share
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SelectStaffDialog
